import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Accordion,
    Form,
    Modal,
    Row,
    Col,
    useAccordionButton,
    Card,
    AccordionContext
} from 'react-bootstrap';
import { useNavigate, Link, useLocation } from 'react-router-dom'
import Header from '../../component/Header/header';
import Spinners from '../../component/Spinner/spinners';
import styles from './DokumenSusulan.module.css';
import ProgressBarDokSul from '../../component/ProgressBarDokSul/progressbardoksul';
import { formatCurrency, getToday, StatusCustomer } from '../../component/Helper';
import { isBrowser, isMobile } from 'react-device-detect';
import SignatureCanvas from "react-signature-canvas";
import { getPendingDocument, rejectPendingDoc, updateStatusSpaj,updateStatusCustomer } from '../../store/features/SPAJSlice';
import AllPagesPDFViewer from "../../component/customPdf/all-pages";
import { getSingleIlustrationSignature, getVideoPending, insertIlustrationSignature } from '../../store/features/CameraAndSignatureSlice';
import cookie from 'js-cookie'
import CreatableSelect from 'react-select/creatable';

const CITY_OPTIONS = [
    { value: 'KOTA ADM. JAKARTA BARAT', label: 'KOTA ADM. JAKARTA BARAT' },
    { value: 'KOTA ADM. JAKARTA PUSAT', label: 'KOTA ADM. JAKARTA PUSAT' },
    { value: 'KOTA ADM. JAKARTA SELATAN', label: 'KOTA ADM. JAKARTA SELATAN' },
    { value: 'KOTA ADM. JAKARTA TIMUR', label: 'KOTA ADM. JAKARTA TIMUR' },
    { value: 'KOTA ADM. JAKARTA UTARA', label: 'KOTA ADM. JAKARTA UTARA' },
    { value: 'KOTA SURABAYA', label: 'KOTA SURABAYA' },
    { value: 'KAB. BANDUNG', label: 'KAB. BANDUNG' },
    { value: 'KAB. BANDUNG BARAT', label: 'KAB. BANDUNG BARAT' },
    { value: 'KOTA BANDUNG', label: 'KOTA BANDUNG' },
    { value: 'KOTA MEDAN', label: 'KOTA MEDAN' },
    { value: 'KAB. SEMARANG', label: 'KAB. SEMARANG' },
    { value: 'KOTA SEMARANG', label: 'KOTA SEMARANG' },
    { value: 'KOTA YOGYAKARTA', label: 'KOTA YOGYAKARTA' },
    { value: 'KOTA DENPASAR', label: 'KOTA DENPASAR' },
    { value: 'KOTA MAKASSAR', label: 'KOTA MAKASSAR' },
    { value: 'KOTA PALEMBANG', label: 'KOTA PALEMBANG' },
    { value: 'KAB. BOGOR', label: 'KAB. BOGOR' },
    { value: 'KOTA BOGOR', label: 'KOTA BOGOR' },
    { value: 'KOTA DEPOK', label: 'KOTA DEPOK' },
    { value: 'KAB. BEKASI', label: 'KAB. BEKASI' },
    { value: 'KOTA BEKASI', label: 'KOTA BEKASI' },
    { value: 'KAB. TANGERANG', label: 'KAB. TANGERANG' },
    { value: 'KOTA TANGERANG', label: 'KOTA TANGERANG' },
    { value: 'KOTA TANGERANG SELATAN', label: 'KOTA TANGERANG SELATAN' }
];


const DokumenSusulanPage = () => {
    const {state} = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const signRef = React.useRef(null);
    const [loading, setLoading] = useState(false);
    const [showHideError, setShowHideError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    let [showHide, setShowHide] = useState(false)
    let [showNotifRev, setshowNotifRev] = useState(false)

    const [isSyariah, setSyariah] = useState(false);
    const [preview, setPreview] = useState(false);
    const [statusCustomer, setStatusCustomer] = useState('');
    const [isUnitLink, setIsUnitLink] = useState(0);
    const [showCanvas, setShowCanvas] = useState(false);
    const { CitySign } = useSelector((state) => state.CitySign);
    const { SPAJs } = useSelector(state => state.SPAJs);
    const { DeviceId } = useSelector(state => state.DeviceId);
    const { SPAJDetail } = useSelector(state => state.SPAJsDetail);

    // INPUT
    const [checkTerm, setCheckTerm] = useState(false)
    const [placeSign, setPlaceSign] = useState("");
    const [dataSign, setDataSign] = useState("");
    const [approvalDocument, setApprovalDocument] = useState([]);
    const [idx, setIdx] = useState(null);

    // Document Preview
    const [lstDoc, setLstDoc] = useState([]);
    const [base64File, setBase64File] = useState(null);
    const [typeFile, setTypeFile] = useState(null);

    useEffect(() => {
        setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink))
        setIsUnitLink(SPAJs.spajHeader?.isUnitLink);
        setSyariah(SPAJs.spajHeader?.isSyariah);
        // signRef.current.off();
        getDocumentPending();
        return () => {}
    }, []);

    const getDocumentPending = async () => {
        try {
            setLoading(true);
            let param = {
                deviceId: `${DeviceId.deviceId}`,
                userName: `${SPAJs.spajHeader?.userName}`,
                spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
            }
            let res = await dispatch(getPendingDocument(param));
            if(res.payload.status == "OK") {
                setApprovalDocument(res.payload.data.docList.map((v) => false));
                setLstDoc(res.payload.data.docList);
                // getSignatureDisclaimer();
                getPendingVideo(res.payload.data.docList);
                // setLoading(false);
            }else {
                setLoading(false);
                let errorMessage = res.payload.errMsg || 'Terjadi Kesalahan'
                setErrorMessage(errorMessage);
                setShowHideError(true);    
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage(error.toString());
            setShowHideError(true);
        }
        
    }

    const getPendingVideo = async (data=[]) => {
        try {

            console.log("getPendingVideo",data)
            let index = data.findIndex((v) => v.uploadFileType == "VIDEO;");
            if (index >= 0) {
                let dataVids = {
                    deviceId: `${DeviceId.deviceId}`,
                    userName: `${SPAJDetail.dataSpaj.email}`,
                    spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
                }
                let res = await dispatch(getVideoPending(dataVids))
                if(res.payload.status == "OK") {
                    if (res.payload.data.isSimpan == "1") {
                        let aprv = approvalDocument.slice();
                        aprv[index] = true;
                        setApprovalDocument(aprv);
                    }
                    setLoading(false);
                }else {
                    setLoading(false);
                    let errorMessage = res.payload.errMsg || 'Terjadi Kesalahan'
                    setErrorMessage(errorMessage);
                    setShowHideError(true);    
                }
            }else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage(error.toString());
            setShowHideError(true);    
        }
    }

    const sendSignature = async () => {
        try {
            let dataSignature = {
                deviceId: `${DeviceId.deviceId}`,
                agentCode: `${SPAJDetail.dataSpaj.agentCode}`,
                leadNumber: `${SPAJDetail.dataPH.TCLN_LeadNumber}`,
                spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
                clientCode: `${SPAJDetail.dataPH.TREL_ClientCode}`,
                clientNumber: `${SPAJDetail.dataPH.TCLN_ClientNumber}`,
                documentId: "DISCLAIMER",
                location: placeSign,
                signatureDate: getToday(), //hanya ambil tanggal saja
                clientSignature: dataSign,
                userName: `${SPAJDetail.dataSpaj.email}`,
            };
            let res = await dispatch(insertIlustrationSignature(dataSignature));
            if(res.payload.status == "OK") {
                navigate( "/otp-konfirmasi");
            }else {
                setLoading(false);
                let errorMessage = res.payload.errMsg || 'Terjadi Kesalahan'
                setErrorMessage(errorMessage);
                setShowHideError(true);
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage(error.toString());
            setShowHideError(true);
        }
        
    }

    const revData = () => {
        setLoading(true)
        setshowNotifRev(false)
        let detailData = {
            deviceId: `${DeviceId.deviceId}`,
            userName: `${SPAJs.spajHeader?.userName}`,
            spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
            agentStatus: "PE",
            customerStatus: "RJP"
        }
        dispatch(rejectPendingDoc(detailData)).then(res => {
            dispatch(updateStatusSpaj(detailData)).then(res => {
                // UPDATE LOCAL STATUS CUSTOMER KE RJP
                dispatch(updateStatusCustomer("RJP"));
                cookie.remove('accessToken');
                cookie.remove('refreshToken');
                localStorage.removeItem("SPAJ_HEADER");
                localStorage.removeItem("TOKEN");
                sessionStorage.removeItem('tokenPayment');
                setLoading(false)
                navigate( "/" + localStorage.getItem("spajHash"));



            })
        })
    }

    const resetSig = () => {
        setDataSign("");
    }

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
        }
    };

    const showTerms = () => {
        setShowHide(true)
    }
    const hideTerms = (e) => {
        setShowHide(false)
    }

    const revisiData = () => {
        setShowHide(false)
        setshowNotifRev(true)
    }

    const captureSign = React.useCallback(() => {
        const dataeSign = signRef.current.toDataURL().split("data:image/png;base64,")[1];
        if(signRef.current.isEmpty() == false){
            setDataSign(dataeSign);
            setShowCanvas(false);
        }
    }, [signRef]);

    const openPreviewDoc = (base64, typeFile, index) => {
        setPreview(true);
        setBase64File(base64);
        setTypeFile(typeFile);
        setIdx(index);
    }

    const closePreviewDoc = () => {
        setPreview(false);
        setBase64File(null);
        setTypeFile(null);
        setIdx(null);
    }

    function checkPending() {
        const hasSubmittedDocument = lstDoc.some((doc) =>
            doc?.uploadFileType == "VIDEO;" || Boolean(doc?.base64Image)
        );

        if (!hasSubmittedDocument) {
            setErrorMessage("Tidak ada dokumen yang dapat disubmit. harap hubungi agent !");
            setShowHideError(true);
            return false;
        }

        let aprv = approvalDocument.filter((v) => v == false);
        
        if (aprv.length > 0) {
            setErrorMessage("Mohon Lengkapi dokumen diatas.");
            setShowHideError(true);
            return false;
        }

        if (!checkTerm) {
            setErrorMessage("Mohon checklist disclaimer diatas.");
            setShowHideError(true);
            return false;
        }

        if (placeSign === "") {
            setErrorMessage("Mohon isi lokasi anda tanda tangan.");
            setShowHideError(true);
            return false;
        }

        if (dataSign === "") {
            setErrorMessage("Mohon tanda tangani disclaimer diatas.");
            setShowHideError(true);
            return false;
        }

        sendSignature();
    }

    const checkTertanggung = (data) => {
        if (data == 0) {
          return "Agent";
        } else if (data == 1) {
          return "Pemegang Polis";
        } else if (data == 2) {
          return "Tertanggung Utama";
        } else {
          return "Tertanggung Tambahan " + (data - 2);
        }
    };

    const renderItems = (item, index) => {
        return (
            <div className={styles.card} key={index}>
                {approvalDocument[index] && <img src="/images/checked.png" width="30" className={styles.checkDoc}/>}
                <p>{item.documentGroup}</p>
                <p>{item.documentName}</p>
                <div style={{marginTop: '20px', textAlign: '-webkit-right'}}>
                    {item.uploadFileType != "VIDEO;" &&
                    <div className={styles.buttonSig}>
                        <button onClick={() => openPreviewDoc(item.base64Image, item.fileType, index)}>Lihat</button>
                    </div>
                    }

                    {item.uploadFileType == "VIDEO;" && 
                    <div className={styles.buttonSig}>
                        <button onClick={() => navigate( '/recording-video', {state: {idx: index}})}>Ambil Video</button>
                    </div>
                    }
                </div>
            </div>
        );
    }

    return (
        <>
            {loading == true && <Spinners/>}
            <div>
                <Header/>
                <div>
                    <div className="welcome-container">
                        <div className={`position-relative ${styles.bgContainer}`}>
                            {/* <ProgressBarDokSul step='1' status={8}/> */}
                            <div className={styles.allCardGreyDoksul}>
                                <div className={`bold`} style={{padding: '0 0 15px 20px'}}>
                                    Daftar Dokumen yang perlu anda periksa.
                                </div>
                                <div className={styles.cardList}>
                                    {lstDoc.map(renderItems)}
                                </div>
                                <div className={styles.containerBtnReject}>
                                    <div className={styles.buttonReject}>
                                        <button onClick={showTerms}>Permintaan Perubahan Data</button>
                                    </div>
                                </div>
                                {!isSyariah && <div className="konven" style={{paddingLeft: '25px', paddingRight: '25px'}}>
                                    <p style={{textAlign: 'justify'}}>1. Calon Pemegang Polis dan/atau Calon Tertanggung, menyatakan dan menjamin kebenaran dan/atau keabsahan dari seluruh keterangan yang diberikan termasuk namun tidak terbatas pada pemberian pernyataan kesehatan dan/atau pernyataan lainnya, sebagaimana dibutuhkan, serta menjamin keaslian tandatangan yang telah dicantumkan dan/atau diberikan kepada PT Asuransi Jiwa Generali Indonesia (“Penanggung”). Calon Pemegang Polis dan/atau Calon Tertanggung dengan ini membebaskan Penanggung dari segala kerugian, klaim, gugatan, tuntutan, dakwaan dan/ atau akibat hukum lain yang ada akibat dari ketidak benaran informasi yang telah dinyatakan dan bersedia untuk menghadapi konsekuensi yang ada atas ketidak benaran informasi tersebut sesuai dengan aturan perundang-undangan yang berlaku.</p>
                                    <p style={{textAlign: 'justify'}}>2. Calon Pemegang Polis dan/atau Calon Tertanggung Utama telah mengisi dan menyetujui seluruh informasi, dan data tambahan yang tercantum pada Kelengkapan Dokumen Tambahan Pengajuan Asuransi.</p>
                                    <p style={{textAlign: 'justify'}}>3. Formulir Konfirmasi ini merupakan bentuk persetujuan Calon Pemegang Polis dan/atau Calon Tertanggung Utama terhadap tambahan kelengkapan dokumen lainnya yang akan menjadi dasar pertanggungan, dan merupakan bagian dari data dan informasi yang dimiliki oleh Calon Pemegang Polis dan/atau Calon Tertanggung.</p>
                                    <p style={{textAlign: 'justify'}}>4. Calon Pemegang Polis dan/atau Calon Tertanggung Utama memahami bahwa selanjutnya kelengkapan Dokumen Tambahan Pengajuan Asuransi tersebut akan dikirimkan secara elektronik melalui aplikasi digital, sehingga dapat memastikan kembali isi dari dokumen-dokumen tersebut.</p>
                                </div>}
                                {isSyariah == true && <div className="syariah" style={{paddingLeft: '25px', paddingRight: '25px'}}>
                                    <p style={{textAlign: 'justify'}}>1. Calon Pemegang Polis dan/atau Calon Peserta, menyatakan dan menjamin kebenaran dan/atau keabsahan dari seluruh keterangan yang diberikan termasuk namun tidak terbatas pada pemberian pernyataan kesehatan dan/atau pernyataan lainnya, sebagaimana dibutuhkan, serta menjamin keaslian tandatangan yang telah dicantumkan dan/atau diberikan kepada PT Asuransi Jiwa Generali Indonesia (“Pengelola”). Calon Pemegang Polis dan/atau Calon Peserta dengan ini membebaskan Pengelola dari segala kerugian, klaim, gugatan, tuntutan, dakwaan dan/ atau akibat hukum lain yang ada akibat dari ketidak benaran informasi yang telah dinyatakan dan bersedia untuk menghadapi konsekuensi yang ada atas ketidak benaran informasi tersebut sesuai dengan aturan perundang-undangan yang berlaku.</p>
                                    <p style={{textAlign: 'justify'}}>2. Calon Pemegang Polis dan/atau Calon Peserta Utama telah mengisi dan menyetujui seluruh informasi, dan data tambahan yang tercantum pada Kelengkapan Dokumen Tambahan Pengajuan Asuransi.</p>
                                    <p style={{textAlign: 'justify'}}>3. Formulir Konfirmasi ini merupakan bentuk persetujuan Calon Pemegang Polis dan/atau Calon Peserta Utama terhadap tambahan kelengkapan dokumen lainnya yang akan menjadi dasar pertanggungan, dan merupakan bagian dari data dan informasi yang dimiliki oleh Calon Pemegang Polis dan/atau Calon Peserta.</p>
                                    <p style={{textAlign: 'justify'}}>4. Calon Pemegang Polis dan/atau Calon Peserta Utama memahami bahwa selanjutnya kelengkapan Dokumen Tambahan Pengajuan Asuransi tersebut akan dikirimkan secara elektronik melalui aplikasi digital, sehingga dapat memastikan kembali isi dari dokumen-dokumen tersebut.</p>
                                </div>}
                                <Form style={{padding: '0px 20px 0px 20px'}}>
                                    <Form.Check
                                        key={`default-checkbox`}
                                        className=' mt-1 mb-3 me-5'
                                        type={'checkbox'}
                                        id={`default-checkbox`}
                                        label={`Saya telah membaca dan memahami Disclaimer diatas`}
                                        defaultValue={checkTerm}
                                        onChange={() => setCheckTerm(!checkTerm)}
                                    />
                                </Form>
                                <div className={styles.canvasContainer}>
                                    <Form
                                    onKeyDown={handleKeyDown}
                                    >
                                        <div className={`bold`}>
                                            Tanda Tangan {checkTertanggung(parseInt(1))} ({SPAJs?.spajHeader?.firstName})
                                        </div>
                                        <Form.Group className="mb-3" controlId="formSign">
                                            <Form.Label className="text-label">Ditandatangani di (Kota / Kabupaten anda)</Form.Label>
                                            <CreatableSelect
                                                value={placeSign ? { value: placeSign, label: placeSign } : null}
                                                onChange={(selectedOption) => setPlaceSign(selectedOption ? selectedOption.value : '')}
                                                options={
                                                    (CitySign && CitySign.length > 0
                                                        ? CitySign
                                                        : CITY_OPTIONS)
                                                }
                                                placeholder="Pilih Kota / Kabupaten"
                                                isClearable
                                                isDisabled={!checkTerm}
                                                formatCreateLabel={(inputValue) => `Tambah: ${inputValue}`}
                                                isValidNewOption={(inputValue) => {
                                                    let dataz = CitySign && CitySign.length > 0 ? CitySign : CITY_OPTIONS
                                                    return (
                                                        inputValue.trim() !== "" &&
                                                        !dataz.some(option => option.label.toLowerCase().includes(inputValue.toLowerCase()))
                                                    );
                                                }}
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        minHeight: '38px',
                                                        borderColor: state.isFocused ? '#dc3545' : base.borderColor,
                                                        boxShadow: 'none',
                                                    }),
                                                }}
                                            />
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className={styles.canvasContainer}>
                                    <div className="font-grey">Bubuhkan tanda tangan anda dibawah ini.</div>
                                    <div className={styles.canvasBorder} onClick={placeSign=="" && checkTerm==false ? null : () => setShowCanvas(true)}>
                                        {dataSign != "" && <img
                                            src={"data:image/png;base64," + dataSign}
                                            className={styles.imgtandatangan}
                                        />}
                                    </div>
                                    <div style={{ marginTop:5 }}>
                                        <button
                                        onClick={resetSig}
                                        >
                                        {" "}
                                        <img
                                            src={
                                            dataSign == ""
                                                ? "/images/deleteGrey.png"
                                                : "/images/delete.png"
                                            }
                                            width="25"
                                        />
                                        </button>
                                    </div>
                                </div>
                                <div className={styles.buttonnext}>
                                    <button onClick={checkPending}>KIRIM</button>
                                </div>
                            </div>
                            <div className={styles.linkFooter}>
                                <div>www.generali.co.id</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal dialogClassName="my-modalcustom-otp" centered className='fs-14' show={preview}>
                <Modal.Header closeButton onClick={closePreviewDoc}>
                <Modal.Title>Preview Dokumen</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body">
                    {typeFile != 'pdf' && <img src={`data:image/png;base64,${base64File}`} className={styles.imgPreview}/>}
                    {typeFile == 'pdf' && <AllPagesPDFViewer pdf={`data:application/pdf;base64,${base64File}`} onLoadSuccess={() => {}} onEndPage={()=> {}} />}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className={'button-red'}
                        type='submit'
                        onClick={e => {
                            let aprv = approvalDocument.slice();
                            aprv[idx] = true;
                            setApprovalDocument(aprv);
                            closePreviewDoc()
                        }}
                    >
                        Saya Menerima
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal dialogClassName={styles.modalcustom} centered show={showHideError}>
                <Modal.Body>
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <p className="fs-15 text-center">{errorMessage}</p>
                    {/* <p className="fs-15 text-center">Ada kesalahan pada saat tanda tangan. Silakan melakukan tanda tangan ulang.</p> */}
                    <div>
                        <button className={styles.buttonkembalimodal} onClick={() => {
                            setErrorMessage("");
                            setShowHideError(false);
                        }}>OK</button>
                    </div>
                </div>
                </Modal.Body>
            </Modal>
            <Modal centered show={showCanvas} key={123456}>
                <div className={styles.videoStream}>

                    <SignatureCanvas
                    ref={signRef}
                    penColor="black"
                    canvasProps={{className: styles.sigCanvas}}
                    clearOnResize={false}
                    />

                </div>
                <div className={styles.containerButtonCamera}>
                <button onClick={captureSign}>
                    <img src="/images/checked.png" width="35" />
                </button>
                <button onClick={() => setShowCanvas(false)}>
                    <img src="/images/close.png" width="35" />
                </button>
                </div>
            </Modal>

            <Modal dialogClassName={styles.modalcustom} centered show={showHide}>
                <Modal.Body>
                    <div className='mt-40'>
                        <p className='fs-15 text-center'>Apakah Anda yakin ingin melakukan perubahan data?</p>
                        <div className='btnmodal'>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }} >
                                <button className={styles.buttonkembalimodal} onClick={() => revisiData()}>
                                    Ya
                                </button>
                                <button className={styles.buttonnextmodal} onClick={() => hideTerms()}>
                                    Tidak
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal dialogClassName={styles.modalcustom} centered show={showNotifRev}>
                <Modal.Body>
                    <div className={styles.containerModal}>
                        <p className='fs-15 text-center mb-25'>Silakan menghubungi Agen Anda untuk perubahan data SPAJ Anda.</p>
                        <div onClick={() => revData()}>
                            <div>
                                <button className={styles.buttonnextmodal}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default DokumenSusulanPage;